import React, { useEffect, useState } from "react";
import { Card, Descriptions, Tag, Button, message, Space, Typography } from "antd";
import adminApi from "./adminApi";
import { environmentVariable } from "../auth/apiRoute";

const { Title, Text } = Typography;

export default function IntegrationsPage() {
  const [status, setStatus] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(true);
  const [testingMs, setTestingMs] = useState(false);
  const [msTestResult, setMsTestResult] = useState(null);

  const loadStatus = async () => {
    setLoadingStatus(true);
    try {
      const { data } = await adminApi.get("/api/admin/integrations/status");
      setStatus(data);
    } catch (error) {
      message.error("Failed to load integration status.");
    }
    setLoadingStatus(false);
  };

  useEffect(() => {
    loadStatus();
  }, []);

  const testMicrosoft = async () => {
    setTestingMs(true);
    setMsTestResult(null);
    try {
      const { data } = await adminApi.post(
        "/api/admin/integrations/microsoft/test"
      );
      setMsTestResult(data);
    } catch (error) {
      setMsTestResult({ connected: false, error: "Request failed." });
    }
    setTestingMs(false);
  };

  const quickbooksConnected =
    status && status.quickbooks.connected && !status.quickbooks.isExpired;

  return (
    <div>
      <Title level={3}>Integrations</Title>
      <Text type="secondary">
        Connection status for QuickBooks and Microsoft/Excel. To manage which
        QuickBooks items and Excel workbooks each event uses, see the Events
        page.
      </Text>

      <div style={{ marginTop: "1rem" }}>
        <Card
          title="QuickBooks"
          loading={loadingStatus}
          style={{ marginBottom: "1.5rem" }}
          extra={
            status ? (
              <Tag color={quickbooksConnected ? "success" : "error"}>
                {quickbooksConnected
                  ? "Connected"
                  : status.quickbooks.connected
                  ? "Token expired"
                  : "Not connected"}
              </Tag>
            ) : null
          }
        >
          <Descriptions column={1} size="small">
            <Descriptions.Item label="Realm ID">
              {(status && status.quickbooks.realmId) || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Token expires">
              {status && status.quickbooks.expiresAt
                ? new Date(status.quickbooks.expiresAt).toLocaleString()
                : "—"}
            </Descriptions.Item>
          </Descriptions>
          <Space style={{ marginTop: "1rem" }}>
            <Button
              type="primary"
              href={environmentVariable.apiURL + "/install-app"}
              target="_blank"
              rel="noreferrer"
            >
              Connect / Reconnect
            </Button>
            <Button
              danger
              href={environmentVariable.apiURL + "/uninstall-app"}
              target="_blank"
              rel="noreferrer"
            >
              Disconnect
            </Button>
          </Space>
        </Card>

        <Card
          title="Microsoft / Excel"
          loading={loadingStatus}
          extra={
            status ? (
              <Tag color={status.microsoft.configured ? "success" : "error"}>
                {status.microsoft.configured
                  ? "Credentials configured"
                  : "Not configured"}
              </Tag>
            ) : null
          }
        >
          <Text type="secondary">
            This integration uses application-only credentials (no per-admin
            login). Use the button below to verify the credentials can reach
            Microsoft Graph.
          </Text>
          <div style={{ marginTop: "1rem" }}>
            <Button onClick={testMicrosoft} loading={testingMs}>
              Test Connection
            </Button>
            {msTestResult ? (
              <div style={{ marginTop: "0.75rem" }}>
                {msTestResult.connected ? (
                  <Tag color="success">Success</Tag>
                ) : (
                  <Tag color="error">{msTestResult.error || "Failed"}</Tag>
                )}
              </div>
            ) : null}
          </div>
        </Card>
      </div>
    </div>
  );
}
